import { Button, type ButtonProps } from '@chakra-ui/react';

/**
 * The neutral action — cancel, back, a secondary choice that should not compete.
 *
 * Styling: `visual.outline`. Pass `elevated` for the raised form; it is a separate recipe axis, so
 * it composes rather than needing a variant of its own.
 */
const OutlinedButton = (props: ButtonProps) => <Button visual="outline" {...props} />;

export default OutlinedButton;
